import { trellisPalette } from "../../../../components/custom/analytics/palettes";
import { Fragment } from "react";
import { FaRegCircle } from "react-icons/fa";
import { Button, TooltipTrigger } from "react-aria-components";
import { css } from "../../../../../styled-system/css";
import { Tooltip } from "../../../../components/core/basic/Tooltip";

type Props = { value?: number | null; trends?: string[] };

export const TrendCell = ({ trends = [], value }: Props) => {
  const COLORS = [
    trellisPalette[17], // -2 red
    trellisPalette[16], // -1 yellow
    "white", // 0 white
    trellisPalette[12] + "80", // 1 light green
    trellisPalette[12], // 2 green
  ];
  let color = "white";
  if (value) {
    color = COLORS[value + 2] ?? "white";
  }
  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      {trends.length > 0 && (
        <TooltipTrigger delay={0}>
          <Button style={{ background: "none", border: "none", padding: 0 }}>
            {color === "white" ?
              <FaRegCircle className={css({ color: "grey" })} />
            : <i className="fa fa-circle" style={{ color }} />}
          </Button>
          <Tooltip>
            {trends.map((t) => (
              <Fragment key={t}>
                {t}
                <br />
              </Fragment>
            ))}
          </Tooltip>
        </TooltipTrigger>
      )}

      {color === "white" && !trends.length ?
        <FaRegCircle style={{ color: "#aaa" }} />
      : null}
    </div>
  );
};
